import React from 'react';

import {
  ProgressContainer,
  ProgressIndicator,
  ProgressIndicatorGrey,
  ProgressInner,
  TextPercentage,
  Wrapper,
} from './styledComponents';

const ProgressBar = ({progress, size = 170, wrapperClassName = ''}) => {
  progress = progress >= 100 ? 100 : progress < 0 ? 0 : progress;

  return (
    <Wrapper size={size} className={wrapperClassName}>
      <ProgressContainer data-value={progress}>
        <ProgressInner>
          <ProgressIndicator value={progress} />
          <ProgressIndicatorGrey value={progress} />
          <TextPercentage className={`font-body-large-semibold`}>{progress}%</TextPercentage>
        </ProgressInner>
      </ProgressContainer>
    </Wrapper>
  );
};

export default ProgressBar;
